
export const TaskHeadings1 = [
    {
        name: 'Car No',
        value: 'carNo'
    },
    {
        name: 'Registration No',
        value: 'registrationNo'
    },
    {
        name: 'Engine No',
        value: 'engineNo'
    },
    {
        name: 'Chasis No',
        value: 'chasisNo'
    },
    {
        name: 'Cab Type',
        value: 'carTypeName'
    },
    {
        name: 'Fuel Type',
        value: 'fuelTypeName'
    },
    {
        name: 'Aggregator',
        value: 'aggregatorCompanyName'
    },
    {
        name: 'Service City',
        value: 'serviceCityName'
    },
    {
        name: 'Permit No',
        value: 'permitNo'
    },

]

export const TaskHeadings2 = [


    {
        name: 'All India Permit No',
        value: 'allIndiaPermitNo'
    },
    {
        name: 'CC Permit No',
        value: 'ccPermitNo'
    },
    {
        name: 'PUC Permit No',
        value: 'pucPermitNo'
    },
    {
        name: 'RC',
        value: 'rc'
    },
    {
        name: 'Fitness Permit No',
        value: 'fitnessPermitNo'
    },
    {
        name: 'Road Tax Permit No',
        value: 'roadTaxPermitNo'
    },
    {
        name: 'Emission',
        value: 'emission'
    },
    {
        name: 'Meter Passing',
        value: 'meterPassing'
    },
    {
        name: 'Insurance Number',
        value: 'insuranceNumber'
    },
]

export const TaskHeadings3 = [
    {
        name: 'Insurance Amount',
        value: 'insuranceAmt'
    },

    {
        name: 'Insurance Company',
        value: 'insuranceCompany'
    },
    {
        name: 'Insurance Contact No',
        value: 'insuranceContactNo'
    },
    {
        name: 'Created on',
        value: 'createdOn'
    },
    {
        name: 'Created by',
        value: 'carCreatedBy'
    },
    // {
    //     name: 'Updated on',
    //     value: 'updatedOn'
    // },
    // {
    //     name: 'Updated by',
    //     value: 'updatedBy'
    // },
    {
        name: 'Deleted on',
        value: 'deletedOn'
    },
    {
        name: 'Deleted by',
        value: 'deletedBy'
    }
]



export const TaskData1 = {
    name: 'John Turner',
    phone_number_1: '+91 7865487640',
    phone_number_2: '+91 7865487640',
    gender: 'Male',
    dob: 'July 9, 1899',
    license_number: 'AN01 /2010/0051926',
    address: 'C/0 K K Complex Arshina Kunate Nelamangala,Banglore-562123',
}

export const TaskData2 = {
    driver_type: 'Primary',
    subscription: 'DODO',
    sevice_city: 'Delhi',
    aggregator: 'Megacabs Pvt. Ltd.',
    cab_type: 'MUV',
    cab_number: 'DL 2 C AD 1234'
}

export const TaskData3 = {
    status: 'Online',
    ratings: '3.5',
    created_on: 'Sep 28,2022',
    created_by: '-',
    deleted_on: '-',
    deleted_by: '-'
}